import { render, staticRenderFns } from "./SocialMedia.vue?vue&type=template&id=29bc91e5&scoped=true&"
import script from "./SocialMedia.vue?vue&type=script&lang=ts&"
export * from "./SocialMedia.vue?vue&type=script&lang=ts&"
import style0 from "./SocialMedia.vue?vue&type=style&index=0&id=29bc91e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bc91e5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
